import { OverflowBadge } from '@dealstack/frontend/app/pages/Valuations/components/OverflowBadgeList/OverflowBadge.tsx';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { LegalPersonTags } from '@dealstack/shared/lib/generated';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { TEST_ELEMENT_IDS, makeComplexDataTestId } from '@dealstack/shared/tests/testElementIds';

const makeBadge = ({
	iconVariant,
	translatedLabel,
	entityTag,
	tCapManage,
	testIdBase,
}: {
	iconVariant?: PredefinedIcons;
	translatedLabel?: string;
	entityTag: LegalPersonTags;
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>;
	testIdBase?: TEST_ELEMENT_IDS;
}) => (
	<OverflowBadge
		key={entityTag}
		badge={{
			id: entityTag,
			label: translatedLabel ? tCapManage(translatedLabel) : entityTag,
			iconVariant,
			testId: testIdBase ? makeComplexDataTestId(testIdBase, entityTag) : undefined,
		}}
	/>
);

export const makeTag = (
	tag: LegalPersonTags,
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>,
	testIdBase?: TEST_ELEMENT_IDS
) => {
	switch (tag) {
		case LegalPersonTags.TARGET:
			return makeBadge({
				iconVariant: 'bulls-eye',
				translatedLabel: 'sidebar.entity_card.badge',
				entityTag: LegalPersonTags.TARGET,
				tCapManage,
				testIdBase,
			});
		case LegalPersonTags.FUND:
			return makeBadge({
				iconVariant: 'money-v3',
				translatedLabel: 'sidebar.entity_card.badge_fund',
				entityTag: LegalPersonTags.FUND,
				tCapManage,
				testIdBase,
			});
		case LegalPersonTags.CO_INVESTOR:
			return makeBadge({
				iconVariant: 'user-profile',
				translatedLabel: 'sidebar.entity_card.badge_co_investor',
				entityTag: LegalPersonTags.CO_INVESTOR,
				tCapManage,
				testIdBase,
			});
		case LegalPersonTags.EXTERNAL_LENDER:
			return makeBadge({
				iconVariant: 'user-profile',
				translatedLabel: 'sidebar.entity_card.badge_external_lender',
				entityTag: LegalPersonTags.EXTERNAL_LENDER,
				tCapManage,
				testIdBase,
			});
		case LegalPersonTags.BID_CO:
			return makeBadge({
				iconVariant: 'user-profile',
				translatedLabel: 'sidebar.entity_card.badge_bid_co',
				entityTag: LegalPersonTags.BID_CO,
				tCapManage,
				testIdBase,
			});
		case LegalPersonTags.SPV:
			return makeBadge({
				iconVariant: 'user-profile',
				translatedLabel: 'sidebar.entity_card.badge_spv',
				entityTag: LegalPersonTags.SPV,
				tCapManage,
				testIdBase,
			});
		case LegalPersonTags.PC_MANAGED:
			return makeBadge({
				iconVariant: 'user-profile',
				translatedLabel: 'sidebar.entity_card.badge_pc_managed',
				entityTag: LegalPersonTags.PC_MANAGED,
				tCapManage,
				testIdBase,
			});
		default:
			return makeBadge({
				entityTag: tag,
				tCapManage,
				testIdBase,
			});
	}
};
